import { AutoScrollContext } from "@/providers/AutoScrollContext/AutoScrollProvider";
import { useContext } from "react";

export const useAutoScrollState = () => useContext(AutoScrollContext);
